module.exports = __webpack_public_path__ + "media/images/icons/chat-message-white-61b27f13eb1d756bb3ec3f576ad7235f.svg";